
const config = {};

config.RealData = true;	// true: call api, false: mockup data

// config.APIHost = 'http://192.168.43.63:8000';   // localhost mobile hotspot



// config.APIHost = 'https://mvis-dp.as.r.appspot.com';   // GAE: MVIS-DP (PROD)





	// config.APIHost = 'https://api-dev-dot-mvis-dp.as.r.appspot.com';	// DEV	====> api-dev จะเลิกใช้แล้ว ไปใช้ api-uat แทน


// config.APIHost = 'http://192.168.1.63:8000';   // localhost home
// config.APIHost = 'http://10.50.51.194:8000';   // localhost office
// config.APIHost = 'https://api-uat-dot-mvis-dp.as.r.appspot.com';   // GAE: MVIS-DP (UAT)
config.APIHost = 'https://mvis-api.isurvey.mobi';   // GAE: MVIS-DP (PROD) - via domain



config.version = "1.2.4";

export default config;